var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9999 14.4246C14.2887 14.4246 16.6726 14.9309 19.1517 15.9436C21.6307 16.9563 22.8703 18.2815 22.8703 19.9193V22.6988H1.12891V19.9193C1.12891 18.2815 2.36844 16.9563 4.84751 15.9436C7.32658 14.9309 9.71049 14.4246 11.9992 14.4246H11.9999ZM11.9999 11.6451C10.5167 11.6451 9.24532 11.1064 8.18571 10.0289C7.12609 8.95143 6.59628 7.65859 6.59628 6.15039C6.59628 4.64219 7.12609 3.33854 8.18571 2.23945C9.24532 1.14037 10.5167 0.59082 11.9999 0.59082C13.4831 0.59082 14.7545 1.14037 15.8141 2.23945C16.8737 3.33854 17.4036 4.64219 17.4036 6.15039C17.4036 7.65859 16.8737 8.95143 15.8141 10.0289C14.7545 11.1064 13.4831 11.6451 11.9999 11.6451Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.0483cc5c63bd413841381f55e51745da.svg";
export { ForwardRef as ReactComponent };